import './lib/proj4'
import Highcharts from 'highcharts'
import moreInit from 'highcharts/highcharts-more'
import mapInit from 'highcharts/modules/map'
import stockInit from 'highcharts/modules/stock'
import timelineInit from 'highcharts/modules/timeline'

import customWorld from '@/maps/custom/world-highres2.json'

moreInit(Highcharts)
mapInit(Highcharts)
stockInit(Highcharts)
timelineInit(Highcharts)

Highcharts.maps['custom/world-highres2'] = customWorld

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    thousandsSep: '',
  },
})

export default Highcharts
